import { Eye, Pencil } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table';
import type { ClientConfig } from '../types';

interface ClientTableProps {
	clients: ClientConfig[];
	onView: (client: ClientConfig) => void;
	onEdit: (client: ClientConfig) => void;
}

export function ClientTable({ clients, onView, onEdit }: ClientTableProps) {
	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>Client ID</TableHead>
					<TableHead>Name</TableHead>
					<TableHead>Email</TableHead>
					<TableHead>Status</TableHead>
					<TableHead>Created At</TableHead>
					<TableHead>Actions</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{clients.map((c) => (
					<TableRow
						key={c.id}
						className="cursor-pointer"
						onClick={() => onView(c)}
					>
						<TableCell className="font-mono text-sm">{c.clientId}</TableCell>
						<TableCell>{c.name}</TableCell>
						<TableCell className="text-muted-foreground">{c.email}</TableCell>
						<TableCell>
							<Badge variant={c.status === 'Active' ? 'default' : 'secondary'}>
								{c.status}
							</Badge>
						</TableCell>
						<TableCell className="text-muted-foreground">{c.created}</TableCell>
						<TableCell>
							<div className="flex gap-1">
								<Button
									variant="ghost"
									size="icon"
									className="h-7 w-7"
									onClick={(e) => {
										e.stopPropagation();
										onView(c);
									}}
								>
									<Eye className="h-3.5 w-3.5" />
								</Button>
								<Button
									variant="ghost"
									size="icon"
									className="h-7 w-7"
									onClick={(e) => {
										e.stopPropagation();
										onEdit(c);
									}}
								>
									<Pencil className="h-3.5 w-3.5" />
								</Button>
							</div>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
}
